'use strict';

module.exports = interrupt;
function interrupt(interruptors, tokenizers, ctx, params) {
  var bools = ['pedantic', 'commonmark'];
  var count = bools.length;
  var length = interruptors.length;
  var index = -1;
  var interruptor;
  var config;
  var fn;
  var offset;
  var bool;
  var ignore;
  while (++index < length) {
    interruptor = interruptors[index];
    config = interruptor[1] || {};
    fn = interruptor[0];
    offset = -1;
    ignore = false;
    while (++offset < count) {
      bool = bools[offset];
      if (config[bool] !== undefined && config[bool] !== ctx.options[bool]) {
        ignore = true;
        break;
      }
    }
    if (ignore) {
      continue;
    }
    if (tokenizers[fn].apply(ctx, params)) {
      return true;
    }
  }
  return false;
}